export class Analytics {
  private version: string;
  private debug: boolean;

  constructor(version: string, debug = false) {
    this.version = version;
    this.debug = debug;
  }

  trackImpression(upc: string, properties: Record<string, any> = {}): void {
    this.track('widget_impression', { upc, ...properties });
  }

  trackModalOpen(upc: string, properties: Record<string, any> = {}): void {
    this.track('widget_modal_open', { upc, ...properties });
  }

  trackClick(upc: string, action: string, properties: Record<string, any> = {}): void {
    this.track('widget_click', { upc, action, ...properties });
  }

  trackError(upc: string, error: string, properties: Record<string, any> = {}): void {
    this.track('widget_error', { upc, error, ...properties });
  }

  trackTrustScoreState(upc: string, isComplete: boolean, widgetType: string, properties: Record<string, any> = {}): void {
    this.track('widget_trust_score_state', { 
      upc, 
      trust_score_complete: isComplete,
      trust_score_state: isComplete ? 'complete' : 'in_progress',
      widget_type: widgetType,
      ...properties 
    });
  }

  trackWidgetValidation(upc: string, isValid: boolean, reason: string, properties: Record<string, any> = {}): void {
    this.track('widget_validation', { 
      upc, 
      is_valid: isValid,
      validation_result: isValid ? 'passed' : 'failed',
      failure_reason: reason,
      ...properties 
    });
  }

  trackPerformance(upc: string, action: string, duration: number, properties: Record<string, any> = {}): void {
    this.track('widget_performance', { 
      upc, 
      action, 
      duration_ms: duration,
      ...properties 
    });
  }

  trackHover(upc: string, widgetType: string, properties: Record<string, any> = {}): void {
    this.track('widget_hover', { 
      upc, 
      widget_type: widgetType,
      ...properties 
    });
  }

  private track(event: string, properties: Record<string, any> = {}): void {
    const eventData = {
      event,
      properties: {
        ...properties,
        // Widget context
        widget_version: this.version,
        widget_domain: window.location.hostname,
        
        // Page context
        page_url: window.location.href,
        page_title: document.title,
        referrer: document.referrer,
        
        // Device context
        user_agent: navigator.userAgent,
        screen_width: window.screen.width,
        screen_height: window.screen.height,
        viewport_width: window.innerWidth,
        viewport_height: window.innerHeight,
        
        // Session context
        timestamp: Date.now(),
        session_id: this.getSessionId()
      }
    };

    if (this.debug) {
      console.log('[SuppCo Widget Analytics]', eventData);
    }

    // Send to available analytics providers
    this.sendToProviders(eventData);
  }

  private getSessionId(): string {
    let sessionId = sessionStorage.getItem('supp_widget_session');
    if (!sessionId) {
      sessionId = 'sw_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('supp_widget_session', sessionId);
    }
    return sessionId;
  }

  private sendToProviders(eventData: any): void {
    // Custom callback for site owner's analytics integration
    if (typeof (window as any).suppcoWidgetAnalytics === 'function') {
      try {
        (window as any).suppcoWidgetAnalytics(eventData);
        if (this.debug) {
          console.log('[SuppCo Widget Analytics] Sent to custom handler:', eventData.event);
        }
      } catch (e) {
        if (this.debug) {
          console.warn('[SuppCo Widget Analytics] Custom callback error:', e);
        }
      }
    } else if (this.debug) {
      console.log('[SuppCo Widget Analytics] No custom handler found. Define window.suppcoWidgetAnalytics to receive events:', eventData);
    }
  }
} 